export function appendUtmParams(url: string): string {
  const utmSource = import.meta.env.VITE_EC_UTM_SOURCE;
  const utmMedium = import.meta.env.VITE_EC_UTM_MEDIUM;
  if (!utmSource) return url;
  const hashIndex = url.indexOf('#');
  const urlBeforeHash = hashIndex !== -1 ? url.slice(0, hashIndex) : url;
  if (/[?&]utm_source=/.test(urlBeforeHash)) return url;
  const utmParams = [
    `utm_source=${encodeURIComponent(utmSource)}`,
    utmMedium ? `utm_medium=${encodeURIComponent(utmMedium)}` : '',
  ].filter(Boolean).join('&');
  const appendQuery = (base: string) => `${base}${base.includes('?') ? '&' : '?'}${utmParams}`;
  return hashIndex !== -1
    ? `${appendQuery(urlBeforeHash)}${url.slice(hashIndex)}`
    : appendQuery(url);
}
